import { Injectable, Injector } from "@angular/core";
import { HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from
  "@angular/common/http";
  import { Observable, throwError, ObservableInput  } from 'rxjs'
import { UserService } from "../../services/user.service";
import { Token } from "../../models/token.model";
import { map, catchError,retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DisplayException } from '../../models/display-exception';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private jwtHelper: JwtHelperService) { 
    this.router = injector.get(Router);    
  }
  private router:Router;
  private authService:UserService;
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {    
    this.authService = this.injector.get(UserService);
    let authToken:Token = this.authService.getAuth();  
    let token = (authToken && authToken.access_token) ? authToken.access_token : null;
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    else {
      request = request.clone();
    }
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
          return event;
      }),retry(1),catchError(this.handleError));    

    // if(authToken) { //authToken && this.jwtHelper.isTokenExpired(token, authToken.expires_in)
    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${token}`
    //     }
    //   });
    // }
    // else {
    //   return next.handle(request).pipe(
    //     map((event: HttpEvent<any>) => {
    //         return event;
    //     }),retry(1),catchError(this.handleError));
    // }
  }
  handleError(error, caught: Observable<HttpEvent<any>>):ObservableInput<any>{
    console.error(error);
    let errorMessage = '';
    if(error.error instanceof DisplayException){
      errorMessage = error.error;
    }
    else if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.error;
    } else {
      // server-side error
      errorMessage = error.error;
    }

    // window.alert(errorMessage);
    if(error.status === 401){
      if(this.authService){
        this.authService.logout();
      }
      if(this.router){
        this.router.navigate(['login']);
      }
    }
    return throwError(errorMessage); 
  }
}
